import store from './index'
import { _http, _api } from '../libs'

//第三方工具使用的module
store.registerModule('third', {
  namespaced: true,
  state: {
    countDown: {
      second: 60,
      text: '发送验证码',
      disable: false
    },
    interVals: [],
    faceVerify: {}
  },

  mutations: {
    SET_COUNT_DOWN(state, second) {
      state.countDown.second = second
      state.countDown.text = second == 0 ? '再次发送' : '请稍等 ' + second
      state.countDown.disable = second ? true : false
    },
    SET_CLEAR_INTERVAL(state) {
      state.interVals.forEach((item) => {
        clearInterval(item)
      })
      state.interVals = []
      state.countDown.second = 60
      state.countDown.text = '发送验证码'
    },
    SET_PUSH_INTERVAL(state, interVal) {
      state.interVals.push(interVal)
    },

    SET_FACE_VERIFY(state, payload) {
      state.faceVerify = payload
    }

  },

  actions: {
    thirdSmsCodeSend(store, param) {
      return _http.get(_api.common.libThird.smsSend, { params: param }).then(() => {
        const _interVal = setInterval(() => {
          store.commit('SET_COUNT_DOWN', store.state.countDown.second - 1)
          if (store.state.countDown.second == 0) {
            clearInterval(_interVal)
            store.state.countDown.second = 60
          }
        }, 1000)
        store.commit('SET_PUSH_INTERVAL', _interVal)
      })
    },
    thirdSmsCodeSendKaptcha(store, param) {
      return _http.get(_api.common.libThird.smsSendKaptcha, { params: param }).then(() => {
        const _interVal = setInterval(() => {
          store.commit('SET_COUNT_DOWN', store.state.countDown.second - 1)
          if (store.state.countDown.second == 0) {
            clearInterval(_interVal)
            store.state.countDown.second = 60
          }
        }, 1000)
        store.commit('SET_PUSH_INTERVAL', _interVal)
      })
    },
    // 上传图片，返回图片相对路径（在OSS中的路径）
    postThirdOss(store, params) {
      return _http.post(_api.common.libThird.oss, params)
    },

    // 人脸识别
    postFaceVerify(store, param) {
      return _http.post(_api.common.libThird.faceVerifyBase64, param).then(payload => store.commit('SET_FACE_VERIFY', payload))
    },

    // 人脸识别
    postFaceVerifyByUrl(store, param) {
      return _http.post(_api.common.libThird.faceVerifyUrl, param).then(payload => store.commit('SET_FACE_VERIFY', payload))
    }
  }

})